var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownvote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0607 13.0606C12.4749 13.6464 11.5251 13.6464 10.9393 13.0606L1.3934 3.51469C0.807612 2.9289 0.807612 1.97915 1.3934 1.39337C1.97918 0.807581 2.92893 0.807581 3.51472 1.39337L12 9.87865L20.4853 1.39337C21.0711 0.807581 22.0208 0.807581 22.6066 1.39337C23.1924 1.97915 23.1924 2.9289 22.6066 3.51469L13.0607 13.0606ZM13.5 10.5V12H10.5V10.5H13.5Z",
    fill: "#C2C2C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownvote);
export default __webpack_public_path__ + "static/media/Downvote.d05dd9ade74f1c97ef9acb3f91cbb152.svg";
export { ForwardRef as ReactComponent };